<template>
    <div class="tw-bg-white">
        <header>
            <div class="tw-container">
                <img src="~@/assets/img/logo.svg">
            </div>
        </header>
        <main class="tw-pt-2 lg:tw-py-5">
            <div class="hero">
                <div class="lg:tw-container tw-flex tw-items-center tw-justify-center tw-flex-col lg:tw-flex-row lg:tw-justify-between">
                    <div class="info-container">
                        <h1>Restam apenas <br class="tw-hidden lg:tw-block"><u>50</u> vagas</h1>
                        <h2>para testar os novos e quase invisíveis<br><b>Aparelhos Auditivos</b> em casa</h2>
                        <div class="counter-container tw-mb-5 tw-mx-auto tw-flex tw-items-center tw-justify-between lg:tw-justify-center tw-gap-8 lg:tw-mb-0 lg:tw-gap-0 lg:tw-flex-col tw-w-full">
                            <div class="counter-title">
                                <h3>Oferta termina em:</h3>
                            </div>
                            <div class="counter">
                                <div>
                                    {{ hours }}
                                    <span>Horas</span>
                                </div>
                                <div>
                                    {{ minutes }}
                                    <span>Minutos</span>
                                </div>
                                <div>
                                    {{ seconds }}
                                    <span>Segundos</span>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="form-container">
                        <div class="title">
                            Teste Grátis Aparelhos Auditivos
                        </div>
                        <FormFB v-if="!$store.state.formSuccess" />
                        <FormSuccessFB v-if="$store.state.formSuccess" />
                    </div>
                </div>
            </div>
        </main>
        <footer>
            <div class="tw-container">
                <p>
                    <span>© {{ new Date().getFullYear() }} Minisom</span><br>
                    A Amplifon Portugal S.A. presta serviços de saúde na área da audiologia e reabilitação auditiva, sendo os seus centros auditivos registados na Entidade Reguladora da Saúde (nº 26950) e os seus técnicos de diagnóstico audiologistas com cédula profissional emitida pela Administração Central do Sistema de Saúde.<br><br>
                    A Amplifon Portugal S.A. disponibiliza nos seus centros auditivos serviços de saúde de reabilitação auditiva com recurso a aparelhos auditivos, que são dispositivos médicos. Deve sempre ler atentamente a rotulagem e as instruções de utilização dos dispositivos médicos. Os aparelhos auditivos são parte da habilitação auditiva e podem precisar ser complementados com treino auditivo e leitura labial e devem ser utilizados apenas conforme orientado e ajustados por um técnico especializado em aparelhos auditivos. A utilização indevida pode resultar em perda auditiva repentina e permanente. Perigo de asfixia e risco de ingerir pilhas e outras peças pequenas. Para mais informações ligue 800 206 740 (chamada gratuita).
                </p>
            </div>
        </footer>
    </div>
</template>
<script>
import moment from 'moment';
import FormFB from '@/components/FormFB.vue';
import FormSuccessFB from '@/components/FormSuccessFB.vue';

export default {
    name: 'Home',
    components: {
        FormFB,
        FormSuccessFB,
    },
    data() {
        return {
            // Countdown
            hours: undefined,
            minutes: undefined,
            seconds: undefined,
        };
    },
    methods: {
        countdown() {
            // In every second, do:
            window.counter = setInterval(() => {
                const now = moment();
                const targetDate = moment().endOf('day');
                const diff = moment.duration(targetDate.diff(now));

                // Get times
                const hours = diff.hours();
                const minutes = diff.minutes();
                const seconds = diff.seconds();

                this.hours = hours.toLocaleString(undefined, { minimumIntegerDigits: 2 });
                this.minutes = minutes.toLocaleString(undefined, { minimumIntegerDigits: 2 });
                this.seconds = seconds.toLocaleString(undefined, { minimumIntegerDigits: 2 });
            }, 1000);
        },
    },
    mounted() {
        this.countdown();
    },
};
</script>
<style lang="scss" scoped>
@import "~@/assets/scss/partials/variables";
@import "~@/assets/scss/partials/_fonts.scss";

header {
    @apply tw-py-4 tw-bg-white;

    @screen lg {
        @apply tw-py-8;
    }

    .tw-container {
        @apply tw-flex tw-items-center tw-justify-center;

        @screen lg {
            @apply tw-justify-start;
        }

        >img {
            @apply tw-pointer-events-none;
            width: 100px;

            @screen lg {
                width: 140px;
            }
        }
    }
}

main {
    color: $text_bf;

    .hero {

        .info-container {

            h1 {
                @apply tw-text-xl tw-font-bold tw-text-center;
                color: $main_color_fb;
                line-height: 32px;

                @screen lg {
                    @apply tw-text-left;
                    font-size: 55px;
                    line-height: 65px;
                    margin-bottom: 10px;
                }
            }

            h2 {
                @apply tw-text-sm tw-mb-3 tw-text-center;
                line-height: 20px;

                @screen lg {
                    @apply tw-text-3xl tw-text-left;
                    line-height: 38px;
                    margin-bottom: 33px;
                }
            }

            .counter-container {

                .counter-title {

                    h3 {
                        @apply tw-font-bold tw-uppercase tw-text-left;
                        color: $main_color;

                        @screen lg {
                            @apply tw-mx-auto tw-text-center tw-block tw-mb-2;
                            font-size: 22px;
                        }
                    }
                }

                .counter {
                    @apply tw-flex tw-items-center tw-justify-center tw-gap-3;

                    @screen lg {
                        @apply tw-gap-8;
                    }

                    >div {
                        @apply tw-relative tw-bg-contain tw-bg-no-repeat tw-bg-center tw-flex tw-items-center tw-justify-center tw-text-center tw-text-white tw-font-bold tw-rounded;
                        background-image: url('~@/assets/img/counter.svg');
                        font-size: 26px;
                        width: 36.3px;
                        height: 41.49px;
                        font-family: $font_secondary;

                        @screen lg {
                            width: 128.79px;
                            height: 147.19px;
                            font-size: 114px;
                            line-height: 58px;
                        }

                        span {
                            @apply tw-absolute tw-w-full tw-text-center tw-left-0 tw-uppercase;
                            bottom: -11.25px;
                            font-size: 7px;
                            color: $text_bf;
                            font-family: $font_base;

                            @screen lg {
                                bottom: -47.5px;
                                font-size: 16px;
                            }
                        }

                        &:last-of-type {
                            color: $main_color_fb;
                        }
                    }
                }
            }
        }

        .form-container {
            @apply tw-w-full tw-relative;
            background-color: $main_color_fb;
            padding: 16px 26px;

            @screen lg {
                padding: 69px 75px 30px 75px;
            }

            .title {
                @apply tw-text-white tw-text-center tw-font-bold tw-absolute tw-hidden;
                font-size: 22px;
                line-height: 27px;
                padding: 10px 27.5px;
                background-color: $text_bf;
                left: 50%;
                transform: translateX(-50%);
                top: -25px;
                border-radius: 5px;
                width: 387px;

                @screen lg {
                    @apply tw-block;
                }
            }

            @screen lg {
                width: 565px;
                border-radius: 5px;
            }
        }
    }
}

footer {
    font-family: $font_base;

    .tw-container {
        padding: 19px 25px 14px 25px;

        @screen lg {
            padding: 67px 0;
        }

        p {
            font-size: 10px;
            line-height: 14px;

            span {

                @screen lg {
                    @apply tw-text-sm;
                    line-height: 20px;
                }
            }

            @screen lg {
                @apply tw-text-xs;
                line-height: 20px;
            }
        }
    }
}
</style>
